import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import {
  MdArrowDropUp,
  MdArrowDropDown,
} from "react-icons/md";

import {
  Container,
  ListContent,
  ListItem,
  ListPermit,
  Title,
  Item,
} from "./styles";

import Accessibility from "../../components/UI/Accessibility";
import Menu from "../../components/UI/Menu";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import FullScreenLoading from "../../components/UI/FullScreenLoading";
import Banner from "../../components/UI/Banner";

// import { useAuth } from "../../hooks/useAuth";
import useApi from "../../hooks/useApi";

const PermissionManager = () => {
  // const { user } = useAuth();
  const [tecnicoDeped,setTecnicoDeped] = useState([]);
  const [userOpen,setUserOpen] = useState(null);
  // const navigate = useNavigate();

  const [selected,setSelected] = useState([]);

  const changeItem = (item)=> {
    if(isSelected(item)){
      setSelected(selected.filter((select)=>{return item!==select;}));
    }
    else{
      setSelected([...selected,item]);
    }
  }

  const isSelected = (item)=> {
    return selected.filter((select)=>{return item===select;}).length>0;
  }

  const [loadTecnicoDeped, loadTecnicoDepedInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/profile/v2",
      method: "get",
      onCompleted: (response) => {
        if (!response.error) {
          console.log("TutorList", response);
          setTecnicoDeped(response.data);
        }
      },
    });

  useEffect(() => {
    //idProfile:"b56d58fe-2377-4428-854d-5f20670fb166" filtra pelo profile "Técnico DEPED"
    loadTecnicoDeped({params:{idProfile:"b56d58fe-2377-4428-854d-5f20670fb166"}});
    // loadTecnicoDeped();
    //eslint-disable-next-line
  }, []);

  return (
    <Container>
      {loadTecnicoDepedInfo.loading && <FullScreenLoading />}
      <Menu />
      <Banner
        icon=""
        url=""
        editorId=""
      >
        GERENCIAMENTO DE PERMISSÕES
      </Banner>
      <ContentBox>
        {userOpen===null && <ListContent visible={true}>
          {tecnicoDeped.map((tecnico)=>(
            <ListItem visible={true} reduct={0} roundborder={true} onClick={()=>{setUserOpen(tecnico)}}>
              {tecnico.name}
              <MdArrowDropDown fontSize={36}/>
            </ListItem>
          ))}
        </ListContent>}
        {userOpen!==null && <ListContent visible={true}>
          <ListItem visible={true} reduct={0} roundborder={true} onClick={()=>{setUserOpen(null)}} selected={true}>
            {userOpen.name}
            <MdArrowDropUp fontSize={36}/>
          </ListItem>
          <ListPermit>
            <Title>Editor</Title>
            <Item check={isSelected(1)} onClick={()=>{changeItem(1)}}>Videoteca</Item>
            <Item check={isSelected(2)} onClick={()=>{changeItem(2)}}>Documentos</Item>
            <Item check={isSelected(3)} onClick={()=>{changeItem(3)}}>Formações</Item>
            <Item check={isSelected(4)} onClick={()=>{changeItem(4)}}>Plataforma</Item>
            <Item check={isSelected(5)} onClick={()=>{changeItem(5)}}>Biblioteca</Item>
            <Item check={isSelected(6)} onClick={()=>{changeItem(6)}}>Agenda</Item>
            <Item check={isSelected(7)} onClick={()=>{changeItem(7)}}>Eventos</Item>
          </ListPermit>
          <ListPermit>
            <Title>Books</Title>
            <Item check={isSelected(8)} onClick={()=>{changeItem(8)}}>Pode Requisitar</Item>
            <Item check={isSelected(9)} onClick={()=>{changeItem(9)}}>Pode Aprovar Requisição</Item>
            <Item check={isSelected(10)} onClick={()=>{changeItem(10)}}>Pode Registrar</Item>
          </ListPermit>
          <ListPermit>
            <Title>Certificate</Title>
            <Item check={isSelected(11)} onClick={()=>{changeItem(11)}}>Pode Gerar</Item>
            <Item check={isSelected(12)} onClick={()=>{changeItem(12)}}>Pode Cancelar</Item>
          </ListPermit>
          <ListPermit>
            <Title>E-Aprendi</Title>
            <Item check={isSelected(13)} onClick={()=>{changeItem(13)}}>Pode Acompanhar E-Aprendi</Item>
          </ListPermit>
          <ListPermit>
            <Title>HTPF</Title>
            <Item check={isSelected(14)} onClick={()=>{changeItem(14)}}>Pode Vizualizar</Item>
            <Item check={isSelected(15)} onClick={()=>{changeItem(15)}}>Pode Gerar</Item>
            <Item check={isSelected(16)} onClick={()=>{changeItem(16)}}>Pode Revisar</Item>
          </ListPermit>

        </ListContent>}
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default PermissionManager;
